import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import Classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    updateSubscriptionValue, 
} from '../../actions/data';
import './CheckBox.css';

// Provides the CheckBox for all the subscriptions
class CheckBox extends PureComponent {

    static defaultProps = {
        subscription: null,
        showLabel: true,
        indent: false,
    };

    constructor(props) {
        super(props);
        
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(){
        const {
            subscription,          
        } = this.props;
        this.props.updateSubscriptionValue(subscription, !subscription.subscribed);
    }

    render() {


        const {
            subscription,
            showLabel,
            indent,
            data,
            params,
        } = this.props;

        // Check if a save is in progress andn this subscription is one of the ones being updated
        const saveInProgress = !data.saveFailed && data.subcriptionsToLock.includes(subscription.name);

        // Set up the label, with a hover is provided by the Category
        const label = showLabel ? 
            
            <Fragment>
                <div
                    data-tip
                    data-for={`hover-tip-${subscription.apiField}`}
                    className='subscription-name'
                >
                    {subscription.label}
                </div>
                {
                    subscription.hover ?
                        <ReactTooltip
                            key={`hover-tip-${subscription.apiField}`}
                            id={`hover-tip-${subscription.apiField}`}
                            type='light'
                            className='subs-tooltip'
                            effect='float'
                            getContent={() => { return null; }}
                            multiline={true}>
                            {subscription.hover}
                            
                        </ReactTooltip>

                        : null
                }
            </Fragment>
            : null;

        let checkBox;
        switch (params.checkBoxStyle) {

            case 'check':
                
                /* Disable mouse pointers when a save is in progress */
                checkBox = 
                    < div
                        className = { Classnames('check-box-icon', indent? 'indent' : '', saveInProgress? 'save-in-progress': '', !showLabel ? 'no-label' : '') }
                        onClick = { this.handleClick.bind(this) }
                            >
                            <FontAwesomeIcon
                                icon={subscription.subscribed ? 'check-square' : ['far', 'square']}
                                size="2x"
                                color={params.checkColorOff}
                            />
                    </div >;
                break;

            case 'slider':
                checkBox =
                    <div
                        className={Classnames('check-box-icon', 'slider-icon', indent ? 'indent' : '', !showLabel ? 'no-label' : '')}>
                        <Switch
                            onChange={this.handleClick.bind(this)} checked={subscription.subscribed}
                            handleDiameter={21}
                            width={51}
                            height={25}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            disabled={saveInProgress}
                            offColor={params.checkColorOff}
                            onColor={params.checkColorOn}
                            activeBoxShadow={`0 0 2px 3px ${params.checkColorOn}`}
                        />
                    </div>
                break;

            case 'square':
                checkBox =
                <div
                    className={Classnames('check-box-icon', 'slider-icon', indent ? 'indent' : '', !showLabel ? 'no-label' : '')}>
                    <Switch
                        onChange={this.handleClick.bind(this)} checked={subscription.subscribed}
                        handleDiameter={26}
                        width={52}
                        height={5}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        disabled={saveInProgress}
                        offColor={'#fff'}
                        onColor={'#fff'}
                        activeBoxShadow={`0 0 2px 3px ${params.checkColorOn}`}
                        borderRadius={0}
                        className={Classnames('square-icon', subscription.subscribed ? '' : 'square-off' )}
                        onHandleColor={params.checkColorOn}
                        offHandleColor={'#fff'}
                    />
                </div>
                break;
            default:
        } 

        return (
            <div className={Classnames('check-box', !showLabel ? 'center' : '')}>
                
                {/* Show the checkbox */}
                {checkBox}                
                
                {/* Show the label */}
                {label}
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        data: state.data,
        params: state.params,
    };
}

export default connect(mapStateToProps,
    {
        updateSubscriptionValue,
    })(CheckBox);
